import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	privateProject: {
		id: 'issue-field-atlas-project-common.atlas-project-smart-link.private-project.non-final',
		defaultMessage: 'Private project',
		description: 'Text to indicate that a given project is private',
	},
	inheritedProject: {
		id: 'issue-field-atlas-project-common.atlas-project-smart-link.inherited-project.non-final',
		defaultMessage: 'Inherited',
		description: 'Text to indicate that a given project is inherited',
	},
	inheritedProjectTooltip: {
		id: 'issue-field-atlas-project-common.atlas-project-smart-link.inherited-project.tooltip.non-final',
		defaultMessage: 'Learn where this project comes from',
		description: 'Tooltip text for inherited project indicator',
	},
});
